export const seriousRelationshipPath = '/serious-relationship'
export const seriousRelationshipFullPath = `${seriousRelationshipPath}/:gender(girls|guys|gays|lesbians)?`
